import { carriersMX, carriersCO } from "../constants/carriers.js"

const addressToString = (obj: any) => (
  `${obj.addresseeAddress1} ${obj.addresseeNumber || ""} ${obj.addresseeIntNumber || ""} ${obj.addresseeColonia} ${obj.addresseeCrossStreet || ""} ${obj.addresseeReference || ""} ${obj.addresseeObservations || ""} ${obj.addresseePhone || ""}`
)

const formatAddress = (addressToFormat: any) => {
  return {
    street: addressToFormat.addresseeAddress1,
    number: addressToFormat.addresseeNumber || "",
    intNumber: addressToFormat.addresseeIntNumber || "",
    suburb: addressToFormat.addresseeColonia,
    crossStreet: addressToFormat.event_type === 'wrong_address' ? "" : (addressToFormat.addresseeCrossStreet || ""),
    zipCode: addressToFormat.addresseeZip,
    locality: addressToFormat.addresseeLocality,
    reference: addressToFormat.event_type === 'wrong_address' ? "" : addressToFormat.addresseeReference,
    observations: addressToFormat.addresseeObservations || "",
    addresseeLat: addressToFormat.addresseeLat,
    addresseeLng: addressToFormat.addresseeLng,
    idOrder: addressToFormat.idOrder,
    eventType: addressToFormat.event_type,
    addresseePhone: addressToFormat.event_type === 'wrong_address' ? "" : (addressToFormat.addresseePhone || ""),
  }
}

const fetchEvent = async (body: any) => {
  const url = process.env.REACT_APP_URL!
  const headers = new Headers();
  headers.append('x-api-key', process.env.REACT_APP_KEY!)
  const init = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  };
  const res = await fetch(url, init)
  return await res.json();
}

const findCountryName = (carrierId: number): string => {
  const carriers = process.env.REACT_APP_COUNTRY === 'MX' ? carriersMX : carriersCO
  return carriers.find((carrier: any) => carrier.idCarrier = carrierId)?.commercialName || ""
}

export {
  formatAddress, fetchEvent, findCountryName, addressToString
}